import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// @ts-ignore
import { makeSelectFinalFormUnsavedValuesExist } from 'services/finalFormsUnsavedValues/selectors';

export interface OwnProps {
    children: React.ReactNode;
    namespace: string;
}

interface StateProps {
    exist?: boolean;
}

interface DispatchProps {}

type Props = StateProps & DispatchProps & OwnProps;

export class FinalFormUnsavedValuesExistGate extends React.PureComponent<
    Props
> {
    render() {
        const { children, exist } = this.props;
        if (!exist) {
            return null;
        }

        return children;
    }
}

// HACK using any
const mapStateToProps = createStructuredSelector<any, any>({
    exist: makeSelectFinalFormUnsavedValuesExist()
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
    FinalFormUnsavedValuesExistGate
);
